import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IDonorProfileHlaInfoData, IDonorProfileHlaInfoLookupData, IDonorProfileHlaInfoPostData } from '@nkr/models/index';

export interface IDonorProfileHlaInfoResponse {
    data: {
        success: boolean;
        results: IDonorProfileHlaInfoData;
    }
}

export interface IDonorProfileHlaInfoPostDataResponse {
    data: {
        success: boolean;
    }
}

export interface IDonorProfileHlaInfoLookupDataResponse {
    data: {
        success: boolean;
        results: IDonorProfileHlaInfoLookupData
    }
}

export const ActionCreators = {
    getProfileHlaInfo: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileHlaInfoResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/hla-info`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    postProfileHlaInfo: (donorId: number, centerId: number, data: IDonorProfileHlaInfoPostData) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileHlaInfoResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/hla-info`,
            data
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getProfileHlaInfoLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileHlaInfoLookupDataResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/hla-info/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    postAutoPopulateHLA: (donorId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/hla-info/auto-populate-hla`,
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    postConfirmHLADiscrepancy: (donorId: number, centerId: number, initials: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/confirm-hla-discrepancy`,
            data: {
                donorId,
                initials
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    }
}